var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34170_45851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52466 12.4122C3.52466 14.1768 4.04792 15.9017 5.02827 17.3689C6.00863 18.8361 7.40204 19.9797 9.03231 20.655C10.6626 21.3302 12.4565 21.5069 14.1872 21.1627C15.9179 20.8184 17.5076 19.9687 18.7553 18.7209C20.0031 17.4732 20.8528 15.8834 21.1971 14.1527C21.5413 12.4221 21.3647 10.6282 20.6894 8.99789C20.0141 7.36762 18.8705 5.9742 17.4033 4.99385C15.9361 4.0135 14.2112 3.49023 12.4466 3.49023C9.95236 3.49962 7.55833 4.47286 5.76505 6.20647L3.52466 8.44686",
    stroke: "white",
    strokeWidth: 2.37918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52466 3.49023V8.44686H8.48128",
    stroke: "white",
    strokeWidth: 2.37918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46893 10.4444V9.37016L12.0254 8.82889V14.7578H10.8679V10.078L9.46893 10.4444ZM13.8638 11.8433C13.8638 12.1375 13.8916 12.4068 13.9471 12.651C14.0026 12.8898 14.0831 13.0979 14.1886 13.2756C14.2941 13.4477 14.419 13.5809 14.5633 13.6753C14.7077 13.7697 14.8687 13.8168 15.0463 13.8168C15.2295 13.8168 15.3933 13.7697 15.5376 13.6753C15.6819 13.5809 15.8068 13.4477 15.9123 13.2756C16.0178 13.0979 16.0983 12.8898 16.1538 12.651C16.2093 12.4068 16.2371 12.1375 16.2371 11.8433C16.2371 11.5491 16.2093 11.2826 16.1538 11.0439C16.0983 10.7996 16.0178 10.5915 15.9123 10.4194C15.8068 10.2417 15.6819 10.1057 15.5376 10.0113C15.3933 9.91697 15.2295 9.86979 15.0463 9.86979C14.8687 9.86979 14.7077 9.91697 14.5633 10.0113C14.419 10.1057 14.2941 10.2417 14.1886 10.4194C14.0831 10.5915 14.0026 10.7996 13.9471 11.0439C13.8916 11.2826 13.8638 11.5491 13.8638 11.8433ZM12.7064 11.8433C12.7064 11.2271 12.8035 10.6942 12.9978 10.2445C13.1977 9.79484 13.4725 9.44788 13.8222 9.20362C14.1775 8.9538 14.5855 8.82889 15.0463 8.82889C15.5237 8.82889 15.9373 8.9538 16.287 9.20362C16.6368 9.44788 16.9088 9.79484 17.1031 10.2445C17.2974 10.6942 17.3946 11.2271 17.3946 11.8433C17.3946 12.4595 17.2974 12.9925 17.1031 13.4421C16.9088 13.8918 16.6368 14.2415 16.287 14.4913C15.9373 14.7356 15.5237 14.8577 15.0463 14.8577C14.5855 14.8577 14.1775 14.7356 13.8222 14.4913C13.4725 14.2415 13.1977 13.8918 12.9978 13.4421C12.8035 12.9925 12.7064 12.4595 12.7064 11.8433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34170_45851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7918,
    height: 23.7918,
    fill: "white",
    transform: "translate(0.550453 0.515625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBackward);
export default __webpack_public_path__ + "static/media/video-backward.976d6b63d9303b9f79633f6857ed22f0.svg";
export { ForwardRef as ReactComponent };